/**
 * @flow
 * @relayHash 075bb8f65938cd36f15d3d2bf95a0f33
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type getLeadFieldsQueryVariables = {|
  propertyId: string
|};
export type getLeadFieldsQueryResponse = {|
  +leadFields: $ReadOnlyArray<{|
    +fieldId: ?string,
    +fieldOptions: ?$ReadOnlyArray<{|
      +default: ?string,
      +display: ?string,
      +id: string,
      +position: ?number,
    |}>,
    +fieldTag: ?string,
    +id: string,
    +label: ?string,
    +type: ?string,
  |}>
|};
export type getLeadFieldsQuery = {|
  variables: getLeadFieldsQueryVariables,
  response: getLeadFieldsQueryResponse,
|};
*/


/*
query getLeadFieldsQuery(
  $propertyId: ID!
) {
  leadFields(propertyId: $propertyId) {
    fieldId
    fieldOptions {
      default
      display
      id
      position
    }
    fieldTag
    id
    label
    type
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "propertyId",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "leadFields",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "propertyId",
        "variableName": "propertyId"
      }
    ],
    "concreteType": "LeadField",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "fieldId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "fieldOptions",
        "storageKey": null,
        "args": null,
        "concreteType": "LeadFieldOption",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "default",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "display",
            "args": null,
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "position",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "fieldTag",
        "args": null,
        "storageKey": null
      },
      (v1/*: any*/),
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "label",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "type",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "getLeadFieldsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "getLeadFieldsQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "getLeadFieldsQuery",
    "id": null,
    "text": "query getLeadFieldsQuery(\n  $propertyId: ID!\n) {\n  leadFields(propertyId: $propertyId) {\n    fieldId\n    fieldOptions {\n      default\n      display\n      id\n      position\n    }\n    fieldTag\n    id\n    label\n    type\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7e38e8a37913b51ec63f500fcbc003dc';
module.exports = node;
